import { styled } from 'stitches.config'
import { Button } from 'components/Button'
export const HistoryRoot = styled('section', {
  backgroundColor: '$tertiary-200',
  paddingTop: '$4',
  paddingBottom: '$4',
  '@bp2': {
    paddingTop: '$9',
    paddingBottom: '$15',
  },
})

export const HistoryHeader = styled('h2', {
  color: '$primary-500',
  textAlign: 'center',
})

export const Subtitle = styled('div', {
  fontSize: '$h4',
  color: '$accent-black',
  textAlign: 'center',
})

export const TimelineContainer = styled('div', {
  paddingTop: '$7',
  '@bp2': {
    paddingTop: '0',
  },
})

export const EventContainer = styled('div', {
  padding: '0',
  '& p': {
    textAlign: 'left !important',
    padding: '0',
  },
  '@bp2': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '$2',
  },
})

export const EventContent = styled('div', {
  width: '25%',
  padding: '0 $10',
})

export const EventTitle = styled('span', {
  fontWeight: '$semiBold',
  color: '$primary-500',
})

export const EventDetails = styled('span', {})

export const ProgressBar = styled('div', {
  paddingTop: '$9',
  position: 'relative',
  height: '4px',
  transition: 'transform 0.6s ease 0s',
  zIndex: '1',
  '@bp2': {
    marginTop: '$9',
  },
  variants: {
    mobile: {
      true: {
        position: 'absolute',
        top: '5px',
        left: '0',
        width: '851vw',
      },
    },
  },
})

export const DottedLine = styled('div', {
  borderTop: '4px dotted $primary-700',
  height: '1px',
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '0',
  '&::before': {
    content: "''",
    width: '15px',
    height: '15px',
    backgroundColor: '$primary-700',
    borderRadius: '50%',
    position: 'absolute',
    top: '-10px',
    left: '0',
  },
  '&::after': {
    content: "''",
    position: 'absolute',
    top: '-2px',
    right: '-3px',
    transform: 'translateY(-50%)',
    border: 'solid transparent',
    borderWidth: '10px 0 10px 17px',
    borderLeftColor: '$primary-700',
  },
})

export const HistoryButton = styled(Button, {
  marginTop: '$4',
})
